import styled from 'styled-components';

interface ITableDataComponent {
  valueColor?: string;
  textAlign?: string;
}

interface ITableHeadAndBodyComponent {
  textColor?: string;
}

const tableComponponent = styled.table`
  display: block !important;
  flex-direction: column;
  width: 100%;
  height: 9rem;
`;

const tableHeadComponent = styled.thead<ITableHeadAndBodyComponent>`
  display: block !important;
  flex-direction: column;
  width: 100%;
  color: ${(props) =>
    props.textColor ? props.textColor : props.theme.colors.gray};
  font-size: 1.25rem;
`;

const tableFootComponent = styled.tfoot<ITableHeadAndBodyComponent>`
  display: block !important;
  flex-direction: column;
  width: 100%;
  color: ${(props) =>
    props.textColor ? props.textColor : props.theme.colors.gray};
  font-size: 1.25rem;

  -ms-overflow-style: none;
  scrollbar-width: none;

  &:-webkit-scrollbar {
    display: none;
  }
`;

const tableBodyComponent = styled.tbody<ITableHeadAndBodyComponent>`
  display: block !important;
  flex-direction: column;
  width: 100%;
  color: ${(props) =>
    props.textColor ? props.textColor : props.theme.colors.gray};
  font-size: 1rem;
  height: 60%;
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &:-webkit-scrollbar {
    display: none;
  }
`;

const tableRowComponent = styled.tr`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 2rem;
`;

const tableDataComponent = styled.td<ITableDataComponent>`
  display: block !important;
  flex-grow: 1;
  min-width: 25%;
  align-items: left;
  justify-content: ${(props) => (props.textAlign ? props.textAlign : 'center')};
  color: ${(props) => (props.valueColor ? props.valueColor : 'inherit')};
  font-size: 1.25rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const TableComponents = {
  Table: tableComponponent,
  Thead: tableHeadComponent,
  Tr: tableRowComponent,
  Td: tableDataComponent,
  Tbody: tableBodyComponent,
  Tfooter: tableFootComponent,
};

export default TableComponents;
